/**
 * @name getInitialRequestTimestamp
 * @param {Boolean} isDuplicateRequest to indicate whether it is a duplicate request
 * @param {Number | String} previousTimestamp Previous request timestamp value
 * @returns {Date} Appropriate timestamp value
 */
export const getInitialRequestTimestamp = (previousTimestamp, isDuplicateRequest = false) => {
  if (!isDuplicateRequest) return Date.now();
  if (!Number.isNaN(+previousTimestamp)) return +previousTimestamp;
  return Date.now();
};
